function fixNumber(num, length) {
  return `${num}`.length < length
    ? (new Array(length + 1).join('0') + num).slice(-length)
    : `${num}`;
}

function getTimeZone() {
  // js获取当前时区换算到GMT时间的小时差取负值再除以60即为时区
  const tz = -new Date().getTimezoneOffset() / 60;
  if (tz < 0) {
    return `-${fixNumber(Math.abs(tz), 2)}:00`;
  }
  return `+${fixNumber(tz, 2)}:00`;
}

function Time() {
  this.client_ts = `${Math.round(new Date().getTime() / 1000)}`;
  this.client_time_zone = `${getTimeZone()}`;
}

Time.prototype = {
  constructor: Time,
};

Time.getTime = () => new Time();

export default Time;



// WEBPACK FOOTER //
// ./src/common/js/model/Time.js